var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 137,
    viewBox: "0 0 160 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3257_4957)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.649 137C150.658 122.458 159.987 102.088 159.987 79.5391C159.987 35.3563 124.17 -0.460938 79.9873 -0.460938C35.8045 -0.460938 -0.0126953 35.3563 -0.0126953 79.5391C-0.0126953 102.088 9.31637 122.458 24.3254 137H135.649Z",
    fill: "url(#paint0_linear_3257_4957)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.362 121.064C128.362 126.067 125.874 128.568 120.898 128.568C115.922 128.568 113.434 126.067 113.434 121.064C113.434 116.062 113.434 125.532 113.434 120.53C113.434 115.528 110.946 113.027 105.971 113.027C100.995 113.027 98.507 115.528 98.507 120.53C98.507 125.532 98.507 116.062 98.507 121.064C98.507 126.067 96.0191 128.568 91.0434 128.568C86.0676 128.568 83.5797 126.067 83.5797 121.064C83.5797 116.062 83.5797 125.532 83.5797 120.53C83.5797 115.528 81.0918 113.027 76.1161 113.027C71.1403 113.027 68.6524 115.528 68.6524 120.53C68.6524 125.532 68.6524 116.062 68.6524 121.064C68.6524 126.067 66.1645 128.568 61.1888 128.568C56.213 128.568 53.7251 126.067 53.7251 121.064V72.838C53.7251 49.8731 66.1645 38.3906 91.0434 38.3906C115.922 38.3906 128.362 49.8731 128.362 72.838V121.064",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.362 121.064C128.362 126.067 125.874 128.568 120.898 128.568C115.922 128.568 113.434 126.067 113.434 121.064C113.434 116.062 113.434 125.532 113.434 120.53C113.434 115.528 110.946 113.027 105.971 113.027C100.995 113.027 98.507 115.528 98.507 120.53C98.507 125.532 98.507 116.062 98.507 121.064C98.507 126.067 96.0191 128.568 91.0434 128.568C86.0676 128.568 83.5797 126.067 83.5797 121.064C83.5797 116.062 83.5797 125.532 83.5797 120.53C83.5797 115.528 81.0918 113.027 76.1161 113.027C71.1403 113.027 68.6524 115.528 68.6524 120.53C68.6524 125.532 68.6524 116.062 68.6524 121.064C68.6524 126.067 66.1645 128.568 61.1888 128.568C56.213 128.568 53.7251 126.067 53.7251 121.064V72.838C53.7251 49.8731 66.1645 38.3906 91.0434 38.3906C115.922 38.3906 128.362 49.8731 128.362 72.838V121.064",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9394 91.4999L85.5891 93.2223",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.9298,
    cy: 74.5657,
    rx: 4.01889,
    ry: 4.01886,
    stroke: "#4A4A4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.0433,
    cy: 74.5657,
    rx: 4.01889,
    ry: 4.01886,
    fill: "#4A4A4A",
    stroke: "#4A4A4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2397 68.5781L13.9283 68.5781L27.53 71.8327L30.2632 73.0819",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2633 68.1093L12.268 72.4152",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2656 63.9844L27.0241 66.3055L14.7624 74.5164L11.9629 77.0822",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9629 63.9844L14.2233 66.419L25.9814 74.2927L29.2657 77.5283",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.2563,
    cy: 70.55,
    rx: 4.59302,
    ry: 4.59298,
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2564 29.207V67.0991",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2564 18.8789V24.6201",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5908 136H140.675",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2565 136H25.8495",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3257_4957",
    x1: 79.9873,
    y1: -46.5943,
    x2: 79.9873,
    y2: 159.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7DAF1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3257_4957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 137,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default __webpack_public_path__ + "static/media/NoResult.ef1d43efc2d237be1f9f666a1dc39b27.svg";
export { ForwardRef as ReactComponent };